/* eslint-disable import/prefer-default-export */
import { css } from '@emotion/core';

// Fix for changes in Chrome that cause these warnings in the console:
//
// > [Intervention] Unable to preventDefault inside passive event listener due to target being treated as
//   passive. See https://www.chromestatus.com/features/5093566007214080
//
// See https://developers.google.com/web/updates/2017/01/scrolling-intervention for background.

export var container = {
  name: "mzl9e8",
  styles: ".slider-list{touch-action:manipulation;}"
};